import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_API + "/api/merchant";

const config = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const updateMerchant = async (id, payload) => {
  try {
    const response = await axios.put(
      `${API_BASE}/UpdateMerchant/${id}`,
      payload,
      config()
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    if (error.response) {
      return { status: error.response.status, data: error.response.data };
    }
    return { status: 500, data: null };
  }
};
